module.exports = __webpack_public_path__ + "static/img/no4.ca1d17c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/awardTW/img/no4.png
// module id = A2NG
// module chunks = 1